export interface IAvailableFromConfig {
  translationId: string;
  apiId: string;
}

export const AVAILABLE_FROM: Array<IAvailableFromConfig> = [
  {
    apiId: "asap",
    translationId: "Co nejdříve",
  },
  {
    apiId: "month",
    translationId: "Příští měsíc",
  },
  {
    apiId: "later",
    translationId: "Později",
  },
];
